import http from '../axios.ts'
import {sha256} from "js-sha256";

const api = {
    /**
     * 新增其他证书
     * @param params
     */
    add(params:Object) {
        const res = http.post('/sslCart/add', params);
        // console.log(res);
        return res;
    },

    /**
     * 分页查询
     * @param params
     */
    getAllByPage(params:Object) {
        const res = http.post('/sslCart/getAllByPage', params);
        // console.log(res);
        return res;
    },

    /**
     * 更具ID查询详情
     * @param params
     */
    getInfoById(params:Object) {
        const res = http.post('/sslCart/getInfoById', params);
        // console.log(res);
        return res;
    },

    /**
     * 修改保存
     * @param params
     */
    update(params:Object) {
        const res = http.post('/sslCart/update', params);
        // console.log(res);
        return res;
    },

    /**
     * 删除
     * @param params
     */
    delete(params:Object) {
        const res = http.post('/sslCart/delete', params);
        // console.log(res);
        return res;
    },
}


export default api
